module.exports = __webpack_public_path__ + "static/media/5.13c82ded.gif";